
export default [{
	path: '/orders',
	component: () => import('@/components/orders/List')
}]
